import axios from "axios";

export async function getSimulator360() {
    const URL = `${process.env.REACT_APP_REPO}/v1/repo_aden/microcontents?simulador360=45`;

    try {
        const request = await axios.get(URL);
        return await request.data.response_data;
    } catch (error) {
        throw new Error(error);
    }
}
